import React from 'react';
import CreateModifierGroupsState from './createModifierGroupsState/CreateModifierGroupsState';
import CreateModifierGroupsControlPanel from './components/CreateModifierGroupsControlPanel/CreateModifierGroupsControlPanel';
import Forms from './components/Forms/Forms';
import ModalWindows from './components/ModalWindows/ModalWindows';
// import style from './index.module.scss';

const CreateModifierGroupsPage: React.FC = () => {
	return (
		<CreateModifierGroupsState>
			<CreateModifierGroupsControlPanel />
			<Forms />
			<ModalWindows />
		</CreateModifierGroupsState>
	);
};

export default CreateModifierGroupsPage;
